/*
 * Copyright © 2018, Rezo Zero
 *
 * @file Point.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

export default class Point {
    constructor (targetX, y) {
        this.targetX = targetX
        this.x = 0
        this.y = y
    }

    grow (t) {
        t = 1 - (--t) * t * t * t // easeOutQuart
        this.x = this.targetX * t
    }
}



// WEBPACK FOOTER //
// ./webpack/js/waveform/Point.js